import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLRPC } from "./getPresignedDownloadUrlRPC";

export class GetPresignedDownloadURLRPCClientImpl extends GetPresignedDownloadURLRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLRPC.Response, GetPresignedDownloadURLRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "file-service/GetPresignedDownloadURL",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLRPC.ResponseDTO,
      GetPresignedDownloadURLRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLRPC.Response,
      GetPresignedDownloadURLRPC.Errors.Errors
    >(
      response,
      "file-service/GetPresignedDownloadURL",
      GetPresignedDownloadURLRPC.Response.fromDTO,
      GetPresignedDownloadURLRPC.Errors.fromDTO
    );
  }
}
